/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 28/07/13
 * Time: 09:22
 * To change this template use File | Settings | File Templates.
 */

angular.module('FlexyBeautyApp.controllers').controller('WorkingPeriodCtrl', ["$scope", function ($scope) {


    $scope.workingPeriods = [];
    $scope.inCreationWorkingPeriod = null;

    $scope.endCellSelection = function () {
        if ($scope.inCreationWorkingPeriod)
            $scope.endWorkingPeriod();
        if ($scope.inCreationBookingFree)
            $scope.endBookingFree();

    }

    $scope.startWorkingPeriod = function (day, hourPart, humanResource) {
        if ($scope.currentWorkingPeriod) {
            //TODO cancel modif ?
        }
        $scope.inCreationWorkingPeriod = new WorkingPeriod(null, day, humanResource, hourPart.startTime, hourPart.endTime);
        $scope.currentWorkingPeriod = $scope.inCreationWorkingPeriod;
        $scope.inCreationWorkingPeriod.addHourPart(day, hourPart, humanResource);

    }
    $scope.setWorkingPeriod = function (day, hourPart, humanResource) {
        if ($scope.inCreationWorkingPeriod)
            $scope.inCreationWorkingPeriod.addHourPart(day, hourPart, humanResource);
        else
            hourPart._display = humanResource;
    }

    $scope.endWorkingPeriod = function () {
        if ($scope.inCreationWorkingPeriod) {
            $scope.inCreationWorkingPeriod.finalize($scope);
            $scope.inCreationWorkingPeriod = null;
            $scope.currentWorkingPeriod = null;
        }
    }
    $scope.workingPeriodClicked = function (workingPeriod) {
        $scope.currentWorkingPeriod = workingPeriod;
    }

    $scope.workingPeriodEditedValidation = function () {
        $scope.currentWorkingPeriod = null;

    }
    $scope.workingPeriodEditedRemove = function (mustRemoveFromInternet, bookingDay) {
        if (mustRemoveFromInternet)
            $scope.currentWorkingPeriod.removeFromInternet(bookingDay);
        else
            $scope.currentWorkingPeriod.remove(bookingDay);
        $scope.currentWorkingPeriod = null;
    }

    $scope.getWorkingPeriodSelectionClass = function (day, hourPart, humanResource, className) {
        //if ($scope.inCreationWorkingPeriod)
        {
            if (humanResource) {
                if (hourPart._selectedForHr && hourPart._selectedForHr === humanResource)
                    return className;
                else if (hourPart.workingHr.indexOf(humanResource) != -1)
                    return className;
            } else if (hourPart._selectedForDefault || hourPart._activeForDefault)
                return className;


            if (day.referenceDay)
                return $scope.getWorkingPeriodSelectionClass(day.referenceDay, day.referenceDay.hourParts[day.hourParts.indexOf(hourPart)], humanResource, className);
        }
        return "";
    }
    $scope.getWorkingPeriodClassNotInherit = function (workingPeriod, className) {
        if (workingPeriod.humanResource && !workingPeriod.inherit) {
            return className;
        }
        return "";
    }


    $scope.getWorkingPeriodTopPos = function (workingPeriod) {
        if (workingPeriod == null)
            return 0;
        var startDateTime = new Date(workingPeriod.startDateTime);
        var pixelByMinute = ($scope.periodHeight * 4) / 60;
        return (startDateTime.getHours() * 60 + startDateTime.getMinutes() - (60 * 10)) * pixelByMinute;
    };
    $scope.getWorkingPeriodInternetTopPos = function (workingPeriod) {
        if (workingPeriod == null)
            return 0;
        var startDateTime = new Date(workingPeriod.internetStartDateTime);
        var pixelByMinute = ($scope.periodHeight * 4) / 60;
        return (startDateTime.getHours() * 60 + startDateTime.getMinutes() - (60 * 10)) * pixelByMinute;
    };
    $scope.getWorkingPeriodLeftPos = function (workingPeriod) {
        if (workingPeriod == null)
            return 0;
        var resource = workingPeriod.humanResource;
        if (resource != null) {
            var indexResource = $scope.humanResourcesToDisplay.indexOf(resource);
            return (($scope.bookingServiceWidth + 9.5) * ($scope.displaySiteTime + indexResource));
        }
        return 0;
    };
    $scope.getWorkingPeriodHeight = function (workingPeriod) {
        if (workingPeriod == null)
            return 0;
        var duration = workingPeriod.endDateTime - workingPeriod.startDateTime; //ms
        var pixelByMinute = ($scope.periodHeight * 4) / 60;
        return (duration * pixelByMinute / (1000 * 60)) - 6;
    };
    $scope.getWorkingPeriodInternetHeight = function (workingPeriod) {
        if (workingPeriod == null)
            return 0;
        var duration = workingPeriod.internetEndDateTime - workingPeriod.internetStartDateTime; //ms
        var pixelByMinute = ($scope.periodHeight * 4) / 60;
        return (duration * pixelByMinute / (1000 * 60)) - 6;
    };

    $scope.getWorkingPeriodDetailsLeftPos = function (workingPeriod) {
        if (workingPeriod == null)
            return 0;
        var resource = workingPeriod.humanResource;
        if (resource != null) {
            var indexResource = $scope.humanResourcesToDisplay.indexOf(resource);
            var leftPos = (($scope.bookingServiceWidth + 10) * (1 + indexResource));

        }
        return 0;
    };
    $scope.getPeriodTimeFromPixelOnY = function (pixel) {
        var pixelByMinute = ($scope.periodHeight * 4) / 60;
        return Math.round(pixel / pixelByMinute * (1000 * 60));
    };

}]);




// WEBPACK FOOTER //
// ./js/controllers/pro/WorkingPeriodCtrl.js